import axios from 'axios';

const baseUrl = `${process.env.REACT_APP_BANK_URL}`;

const getData = async () => {
 return await axios.get(baseUrl).then(response =>  response);
};

export const bankService = {
  getData,
};
